import React from 'react';
import styled from 'styled-components';

import { EntryPointItemRow } from 'src/presentation/components/pages/channels/entryPoints/components/EntryPointLayouts';
import InformationIcon from '@ad-scripts/presentation/components/common/icons/fill/information-fill';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';

export default function EntryPointExceptionHeader({
  inboxHeaderName = 'Inbox',
  hideEntryPointColumn,
}: {
  inboxHeaderName?: string;
  hideEntryPointColumn?: boolean;
}): JSX.Element | null {
  const entryPointColumn = !hideEntryPointColumn ? <HeaderColumn>Entry Point</HeaderColumn> : undefined;

  return (
    <EntryPointItemRow
      entryPointElement={entryPointColumn}
      inboxElement={<HeaderColumn>{inboxHeaderName}</HeaderColumn>}
      slaElement={
        <HeaderColumn>
          Entry Point SLA (minutes){' '}
          <StyledTooltip
            data-aid="sla-column-tooltip"
            message={
              <>
                Enter Entry Point SLA <br /> to override Inbox SLA
              </>
            }
          >
            <StyledInformationIcon />
          </StyledTooltip>
        </HeaderColumn>
      }
    />
  );
}

const StyledTooltip = styled(Tooltip)`
  line-height: 1;
`;

const StyledInformationIcon = styled(InformationIcon)`
  fill: ${p => p.theme.colors.gray600};
  height: ${p => p.theme.iconSize.xsmall};
  width: ${p => p.theme.iconSize.xsmall};
`;

export const HeaderColumn = styled.div`
  align-items: center;
  display: flex;
  font-weight: ${p => p.theme.fontWeight.heavy};
  gap: 4px;
  line-height: ${p => p.theme.lineHeight.base};
  white-space: nowrap;
`;
